import { render, staticRenderFns } from "./ToggleDisallowErrors.vue?vue&type=template&id=cdfa31e8&scoped=true"
import script from "./ToggleDisallowErrors.vue?vue&type=script&lang=ts"
export * from "./ToggleDisallowErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa31e8",
  null
  
)

export default component.exports